import IconGlyph from '@/bit/components/components.icon-glyph';
import { COLOR_DICTIONARY } from '@gcloud-npm/utils.enums.colors';

function SimpleFooter({ cyData }) {
  return (
    <footer data-cy={cyData}>
      <div className="container">
        <div className="SimpleFooter">
          <IconGlyph
            id="telefonica-reducido"
            alt="telefonica-reducido"
            kind="m"
            color={COLOR_DICTIONARY.BLUEB}
            layoutSize={{ width: 140 }}
            cyData={`${cyData}__icon`}
          />
        </div>
      </div>
      <style jsx>
        {`
          .SimpleFooter {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 16px 0 32px 0;
          }
        `}
      </style>
    </footer>
  );
}
export default SimpleFooter;
